import { scorecardGenerationToolOptions } from './constants';
import type { ScorecardGenerationExternalTool } from './types';

interface ScorecardGenerationToolControlProps {
    value: ScorecardGenerationExternalTool;
    disabled: boolean;
    onChange: (value: ScorecardGenerationExternalTool) => void;
}

const ScorecardGenerationToolControl = ({ value, disabled, onChange }: ScorecardGenerationToolControlProps) => (
    <div className="flex flex-wrap gap-1 rounded-lg bg-zinc-800 p-1">
        {scorecardGenerationToolOptions.map((option) => (
            <button
                aria-pressed={value === option.value}
                className={`rounded px-3 py-1.5 text-sm font-medium transition-colors ${
                    value === option.value ? 'bg-zinc-700 text-white' : 'text-zinc-400 hover:text-zinc-200'
                }`}
                disabled={disabled}
                key={option.value}
                type="button"
                onClick={() => onChange(option.value)}
            >
                {option.label}
            </button>
        ))}
    </div>
);

export default ScorecardGenerationToolControl;
